import { Component } from '@angular/core';
import { ContactFormInfo } from 'src/app/interfaces/contact-form-info';
import { IWizard } from 'src/app/interfaces/iwizard';
import { WizardSteps } from 'src/app/interfaces/wizard-steps';
import { EnrollmentService } from 'src/app/services/enrollment.service';
import { GeneralService } from 'src/app/services/general.service';

@Component({
    selector: 'app-s-all-done-error',
    templateUrl: './s-all-done-error.component.html',
    styleUrls: ['./s-all-done-error.component.scss'],
    standalone: false
})
export class SAllDoneErrorComponent {
    contactFormInfo: ContactFormInfo | any;
    constructor(public generalService: GeneralService, public enrollmentService: EnrollmentService) {

        this.setContactInfo();
    }

    wizardObj: IWizard = {
        steps: [
            { step: 1, text: 'Welcome' } as WizardSteps,
            { step: 2, text: 'Company Information' } as WizardSteps,
            { step: 3, text: 'User Accounts' } as WizardSteps,
            { step: 4, text: 'Review' } as WizardSteps,
            { step: 5, text: 'Contract Documents' } as WizardSteps,
            { step: 6, text: 'Submit' } as WizardSteps,
            { step: 7, text: 'Billing Information' } as WizardSteps
        ]
    };

    ngOnInit(): void {
         setTimeout(() => this.scrollToTop(), 500);
    }

    translate_local(translationTag: string) {
        let translatedText: string = this.generalService.getTranslation(translationTag)
        if (translatedText === undefined) {
            translatedText = this.generalService.getTranslation(translationTag);
        }
        return translatedText;
    }

    setContactInfo() {
        this.contactFormInfo = {
            contactName: this.enrollmentService.contactName,
            contactEmail: this.enrollmentService.powerUser?.email,
            errorSummary: this.translate_local('PayErrorHeading_sub'),
            header: this.translate_local('PayErrorHeading'),
            message: this.translate_local('PayErrorContent') + ' \'' + this.enrollmentService.companyName + '\'\n',
            optionalReason: this.translate_local('CsInfoPart1'),
            contactPhone: this.enrollmentService.powerUser?.primaryPhoneNumber,
            topic: (this.enrollmentService.EnrolledError === true ? 'Enrollment' : 'Payment Setup')
        }
    }

    scrollToTop() {
        window.scrollTo(0, 0);
    }

    ngOnDestroy() {
        this.enrollmentService.clearAll();
    }
}
